<template>
  <!-- START : Shopping List Header -->
  <div class="shopping-list__header d-flex justify-content-between align-items-center">
    <!-- START : Shopping List Title -->
    <router-link
      class="shopping-list__header__title h3 underline-link-from-center mb-0"
      :to="`/me/list/${shoppingList.id}`"
      v-if="shoppingList.count"
    >
      <WCShoppingListIcon
        v-if="shoppingList.type"
        class="text-primary mr-2"
        :shoppingListType="shoppingList.type"
      />
      {{ shoppingList.name }}
    </router-link>
    <div class="shopping-list__header__title h3 mb-0 text-primary" v-else>
      <WCShoppingListIcon
        v-if="shoppingList.type"
        class="text-primary mr-2"
        :shoppingListType="shoppingList.type"
      />
      {{ shoppingList.name }}
    </div>
    <!-- END : Shopping List Title -->
    <!-- START : Shopping List Btn Section -->
    <div>
      <button
        v-if="hasDelete"
        class="shopping-list__delete-btn btn btn-link underline-link-from-center my-0"
        @click="deleteList()"
        :aria-label="$t('deleteList')"
      >
        <span class="h3 d-none d-sm-inline mb-0">{{ $t('deleteList') }}</span>
        <font-awesome-icon class="d-inline d-sm-none" icon="trash" size="lg" />
      </button>
      <router-link
        :aria-label="viewManageListLabelText(shoppingList.name)"
        class="btn btn-link underline-link-from-center my-0"
        :to="`/me/list/${shoppingList.id}`"
        v-if="shoppingList.count"
      >
        <span class="h3 d-none d-sm-inline mb-0">{{ $t('viewManageList') }}</span>
        <font-awesome-icon class="d-inline d-sm-none" icon="pencil" size="lg" />
      </router-link>
    </div>
    <!-- END : Shopping List Btn Section -->
  </div>
  <!-- END : Shopping List Header -->
</template>
<script>
import WCShoppingListIcon from '../WCShoppingListIcon/WCShoppingListIcon.vue';

export default {
  name: 'WCShoppingListHeader',
  components: { WCShoppingListIcon },
  props: {
    shoppingList: Object,
    icon: {
      type: String,
      required: false,
    },
    hasDelete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['deleteList'],
  methods: {
    deleteList() {
      this.$emit('deleteList');
    },
    viewManageListLabelText(shoppingListName) {
      return this.$t('viewManageShoppingList', { shoppingListName });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

@include media-breakpoint-down(md) {
  .shopping-list {
    &__header {
      padding: $pad-2 $pad-3;
      background-color: var(--secondary-lighter-7);
    }
  }
}
</style>
